// import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { Image, TouchableOpacity } from 'react-native'

import { Text } from 'native-base'

import { logRender } from 'x/utils/util'
import xCONS from 'x/config/constants'
import _ from 'lodash'
import { Map } from 'immutable'
import XCard from 'xui/components/XCard'
import XIcon from 'xui/components/XIcon'
import { COLORS, STYLES } from 'x/config/styles'
import HStack from 'xui/components/HStack'
import XText from 'xui/components/XText'
import XImage from 'xui/components/XImage'
import VStack from 'xui/components/VStack'
import { APP_CONFIG } from 'x/config/mode'

const { CARD_COMMON } = STYLES

export default class StoreCard extends PureComponent {
  // static propTypes = {
  //   index: PropTypes.number.isRequired,
  //   data: PropTypes.any.isRequired, // Immutable.Map
  //   // id: PropTypes.number.isRequired,
  //   // role_id: PropTypes.number,
  //   // name: PropTypes.string.isRequired,
  //   // imgUri: PropTypes.string,
  //   // lastUpdated: PropTypes.string.isRequired, //  React.PropTypes.instanceOf(Date),
  //   onPress: PropTypes.func.isRequired,
  //   // myTaskCount: PropTypes.number,
  //   showCreateOrder: PropTypes.bool,
  // }

  static defaultProps = {
    showCreateOrder: false,
    myTaskCount: -1,
    role_id: 1,
  }

  constructor(props) {
    super(props)
    // log('StoreCard', props)
    // this._getCreateOrderButton = this._getCreateOrderButton.bind(this)
    // this._getMyTasksButton = this._getMyTasksButton.bind(this)
  }

  _onPress = () => {
    const { index, data, onPress } = this.props
    if (_.isFunction(onPress)) {
      onPress(index, data)
    }
  }

  render() {
    logRender(this)
    const { data } = this.props
    if (!Map.isMap(data)) {
      return null
    }
    // console.log('data=', data.toJS())
    const id = data.get('id')
    const name = data.get('name')
    const imgUri = data.get('cover_thumbnail_uri')
    // const lastUpdated = data.get('lastUpdated')
    // const myTaskCount = data.get('myTaskCount')
    const role_id = data.get('role_id') || xCONS.STORE_ROLE.OWNER // default to 1

    // TODO: Remove Me
    // console.log('Render: ' + this.props.test)
    const isStoreHelper = role_id === xCONS.STORE_ROLE.HELPER
    const description = data.get('description') || null
    const isPendingStore = data.has('isPending')
    const showArrowIcon = APP_CONFIG.seller_stores.can_select_store
    return (
      <XCard key={`mstore_${id}`} flex={1} disabled={isPendingStore} onPress={this._onPress} m='1'>
        <HStack w={'full'} alignItems={'center'} style={{ backgroundColor: isStoreHelper ? COLORS.FORM_PRIMARY_BG : 'white' }} p='2'>
          <HStack w='16'>
            {imgUri ? <XImage resizeMode='cover' style={{ alignSelf: 'center', width: 60, height: 60 }} source={{ uri: imgUri }} /> : null}
          </HStack>
          <VStack flex={1} ml='2'>
            <XText allowFontScaling={false} numberOfLines={1} variant={isPendingStore ? 'inactive' : 'active'} fontSize='md'>
              {name}
            </XText>
            <XText allowFontScaling={false} numberOfLines={2} variant='inactive'>
              {description || '(ไม่มีคำอธิบายร้าน)'}
            </XText>
            {isStoreHelper ? <XText variant='inactive'>(ฉันเป็นผู้ช่วยร้านนี้)</XText> : null}

            {isPendingStore ? (
              <XText allowFontScaling={false} numberOfLines={1} position='absolute' bottom='0' right='0' textAlign='right'>
                รอการอนุมัติคำขอเข้ากลุ่ม
              </XText>
            ) : null}
          </VStack>
          {isPendingStore || !showArrowIcon ? null : (
            <HStack w='8'>
              <XIcon
                // allowFontScaling={false}
                name='arrow-forward'
                color={COLORS.APP_MAIN}
              />
            </HStack>
          )}
        </HStack>
      </XCard>
    )
    return (
      <XCard key={`mstore_${id}`} w='full' onPress={this._onPress}>
        <XCard.Body style={{ backgroundColor: isStoreHelper ? COLORS.FORM_PRIMARY_BG : 'white' }}>
          <HStack w='full'>
            <XText>{name}</XText>
            {isStoreHelper ? <XText variant='inactive'>(ฉันเป็นผู้ช่วยร้านนี้)</XText> : null}
            <XIcon
              // allowFontScaling={false}
              name='arrow-forward'
              active
            />

            {imgUri ? <XImage resizeMode='cover' style={s.cardImg} source={{ uri: imgUri }} /> : null}
          </HStack>
        </XCard.Body>
      </XCard>
    )
  }

  _getMyTasksButton(count) {
    if (this.props.myTaskCount >= 0) {
      return (
        <TouchableOpacity>
          <XIcon active name='refresh' />
          <XText style={s.txtNormal}>{`รอฉัน ${count}`}</XText>
        </TouchableOpacity>
      )
    }
    return null
  }

  _getCreateOrderButton() {
    if (this.props.showCreateOrder) {
      return (
        <TouchableOpacity>
          <XIcon active name='create' />
          <XText style={s.txtNormal}>สร้างใบสั่งซื้อ</XText>
        </TouchableOpacity>
      )
    }
    return null
  }
}

const s = {
  // myStoreContainer: {
  //   flex: 1,
  //   flexDirection: 'column',
  //   justifyContent: 'center',
  //   alignItems: 'center',
  //   backgroundColor: COLORS.MY_STORE_MAIN,
  // },
  sellerStoreContainer: {
    paddingLeft: 5,
    paddingRight: 5,
    backgroundColor: COLORS.RESELLER_STORE_MAIN,
  },
  cardStyle: {
    // elevation: 3,
    flex: 1,
    marginLeft: 5,
    marginRight: 5,
  },
  cardBody: {
    width: '100%',
    height: 220,
  },
  cardImg: {
    alignSelf: 'center',
    width: '100%',
    height: 200,
  },
  textEmptyStore: {
    marginTop: '40%',
    alignSelf: 'center',
  },
  txtHeader: {
    fontSize: STYLES.FONT_SIZE_ORDERS_HEADER_ROW2,
    fontWeight: 'bold',
  },
  txtNormal: {
    fontSize: STYLES.FONT_SIZE_NORMAL,
  },
}
